import { PRIORIDADE_LABELS, STATUS_LABELS } from './constants'

export function formatMoney(value: string | number | null | undefined) {
  if (value == null || value === '') return null
  const n = typeof value === 'number' ? value : Number(value)
  if (Number.isNaN(n)) return null
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 })
}

export function formatSalario(
  min?: string | number | null,
  max?: string | number | null,
  oculto?: boolean,
) {
  if (oculto) return 'A combinar'
  const a = formatMoney(min)
  const b = formatMoney(max)
  if (a && b && a !== b) return `${a} – ${b}`
  return a || b || '—'
}

export function formatLocal(cidade?: string, uf?: string) {
  if (cidade && uf) return `${cidade}/${uf}`
  return cidade || uf || '—'
}

export function statusLabel(status?: string) {
  if (!status) return '—'
  return STATUS_LABELS[status] || status
}

export function prioridadeLabel(p?: string) {
  if (!p) return '—'
  return PRIORIDADE_LABELS[p] || p
}

export function initials(nome?: string) {
  if (!nome) return '?'
  const parts = nome.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
}

/** Tom do .badge-status do legado para vagas e requisições. */
export function statusTone(status?: string): 'ativo' | 'pendente' | 'inativo' {
  switch (status) {
    case 'aberta':
    case 'aprovado':
    case 'em_andamento':
      return 'ativo'
    case 'pendente_aprov':
    case 'info_solicitada':
    case 'rascunho':
      return 'pendente'
    default:
      return 'inativo'
  }
}